import React from "react";
import PropTypes from "prop-types";

const toastContainerStyle = {
  position: "fixed",
  top: 20,
  right: 20,
  zIndex: 10000,
  minWidth: 250,
  maxWidth: 420,
  padding: "12px 18px",
  borderRadius: 8,
  color: "#fff",
  fontWeight: 500,
  boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
  animation: "slideInToast 0.3s ease",
};

const ToastMessage = ({ toast }) => {
  if (!toast) return null;

  return (
    <>
      <div
        style={{
          ...toastContainerStyle,
          background: toast.type === "success" ? "#10b981" : "#ef4444",
        }}
      >
        {toast.message}
      </div>

      <style>{`
        @keyframes slideInToast {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
};

ToastMessage.propTypes = {
  toast: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
  }),
};

export default ToastMessage;